import { Component, Input, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { HintsService } from 'shared/hints/hints.service';
import { SegmentValidationService } from 'shared/validation/segment-validation/segment-validation.service';
import {takeWhile} from 'rxjs/operators';



@Component({
  moduleId: module.id,
  selector: 'hints-tab',
  templateUrl: 'hints-tab.component.html',
  styleUrls: ['hints-tab.component.scss'],
})
export class HintsTabComponent implements OnInit, OnDestroy {

  isValidationHidden: boolean = false;
  private isPageActive: boolean = true;

  constructor(
    private hintsService: HintsService,
    private validationService: SegmentValidationService,
    private ref: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.hintsService.showHintEvent
    .pipe(takeWhile(() => this.isPageActive))
    .subscribe((hintModel: any) => {
      this.isValidationHidden = !hintModel.isHintDefault;
      this.ref.markForCheck();
    });
  }

  ngOnDestroy() {
    this.isPageActive = false;
  }
}
